<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="toc">Contents</h1>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780545388856_epub_cvi_r1.htm">Cover</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780545388856_epub_tp_r1.htm">Title Page</a></p>
<p class="nonindent" id="c01"><a class="hlink" href="#/OEBPS/9780545388856_epub_c01_r1.htm">CHAPTER ONE</a></p>
<p class="nonindent" id="c02"><a class="hlink" href="#/OEBPS/9780545388856_epub_c02_r1.htm">CHAPTER TWO</a></p>
<p class="nonindent" id="c03"><a class="hlink" href="#/OEBPS/9780545388856_epub_c03_r1.htm">CHAPTER THREE</a></p>
<p class="nonindent" id="c04"><a class="hlink" href="#/OEBPS/9780545388856_epub_c04_r1.htm">CHAPTER FOUR</a></p>
<p class="nonindent" id="c05"><a class="hlink" href="#/OEBPS/9780545388856_epub_c05_r1.htm">CHAPTER FIVE</a></p>
<p class="nonindent" id="c06"><a class="hlink" href="#/OEBPS/9780545388856_epub_c06_r1.htm">CHAPTER SIX</a></p>
<p class="nonindent" id="c07"><a class="hlink" href="#/OEBPS/9780545388856_epub_c07_r1.htm">CHAPTER SEVEN</a></p>
<p class="nonindent" id="c08"><a class="hlink" href="#/OEBPS/9780545388856_epub_c08_r1.htm">CHAPTER EIGHT</a></p>
<p class="nonindent" id="c09"><a class="hlink" href="#/OEBPS/9780545388856_epub_c09_r1.htm">CHAPTER NINE</a></p>
<p class="nonindent" id="p01"><a class="hlink" href="#/OEBPS/9780545388856_epub_p01_r1.htm">MY ADVENTURES IN HOLLYWOOD — PART ONE</a></p>
<p class="nonindent" id="c10"><a class="hlink" href="#/OEBPS/9780545388856_epub_c10_r1.htm">CHAPTER TEN</a></p>
<p class="nonindent" id="p02"><a class="hlink" href="#/OEBPS/9780545388856_epub_p02_r1.htm">MY ADVENTURES IN HOLLYWOOD — PART TWO</a></p>
<p class="nonindent" id="c11"><a class="hlink" href="#/OEBPS/9780545388856_epub_c11_r1.htm">CHAPTER ELEVEN</a></p>
<p class="nonindent" id="c12"><a class="hlink" href="#/OEBPS/9780545388856_epub_c12_r1.htm">CHAPTER TWELVE</a></p>
<p class="nonindent" id="c13"><a class="hlink" href="#/OEBPS/9780545388856_epub_c13_r1.htm">CHAPTER THIRTEEN</a></p>
<p class="nonindent" id="c14"><a class="hlink" href="#/OEBPS/9780545388856_epub_c14_r1.htm">CHAPTER FOURTEEN</a></p>
<p class="nonindent" id="c15"><a class="hlink" href="#/OEBPS/9780545388856_epub_c15_r1.htm">CHAPTER FIFTEEN</a></p>
<p class="nonindent" id="c16"><a class="hlink" href="#/OEBPS/9780545388856_epub_c16_r1.htm">CHAPTER SIXTEEN</a></p>
<p class="nonindent" id="c17"><a class="hlink" href="#/OEBPS/9780545388856_epub_c17_r1.htm">CHAPTER SEVENTEEN</a></p>
<p class="nonindent" id="c18"><a class="hlink" href="#/OEBPS/9780545388856_epub_c18_r1.htm">CHAPTER EIGHTEEN</a></p>
<p class="nonindent" id="bm"><a class="hlink" href="#/OEBPS/9780545388856_epub_bm_r1.htm">Preview</a></p>
<p class="nonindent" id="als"><a class="hlink" href="#/OEBPS/9780545388856_epub_als_r1.htm">Also by Lois Duncan</a></p>
<p class="nonindent" id="ata"><a class="hlink" href="#/OEBPS/9780545388856_epub_ata_r1.htm">About the Author</a></p>
<p class="nonindent" id="cop"><a class="hlink" href="#/OEBPS/9780545388856_epub_cop_r1.htm">Copyright</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780545388856_epub_toc_r1.vue?3d00bbbe